// @ts-nocheck
import { Box, useMediaQuery } from "@mui/material";

const ReusableParentContainer = ({ children, style }) => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  return (
    <>
      <Box
        sx={{
          position: style?.position || "static",
          width: style?.width || "100%",
          height: style?.height || "100%",
          maxWidth: "95vw",
          maxHeight: "95vh",
          borderRadius: style?.borderRadius || "16px",
          padding: style?.padding || "20px",
          border: style?.border || "2px solid #D175B6",
          background: style?.background || "rgba(0, 0, 0, 0.50)",
          boxShadow: `7px 7px 20px rgba(209, 117, 182, 0.15), 
                        -7px 7px 20px rgba(209, 117, 182, 0.15)`,
          display: "flex",
          justifyContent: style?.justifyContent || "center",
          alignItems: style?.alignItems || "center",
          top: style?.top || "0",
          left: style?.left || "0",
          "@media (max-width: 600px)": {
            overflowY: "auto",
            overflowX: "hidden",
            position: "relative",
            width: "97vw",
            // maxWidth: "97vw",
          },
          ...style,
        }}
        className={isSmallScreen ? "custom-scroll-design" : ""}
      >
        {children}
      </Box>
    </>
  );
};

export default ReusableParentContainer;